import { Pipe, PipeTransform } from '@angular/core';

@Pipe({name:'showYear'})
export class showYearPipe implements PipeTransform{
	transform(value:any):number{
		if(!value) return value;
		return new Date(value).getFullYear();
	}
}
